import {makeStyles} from "@material-ui/styles";


const useStyles = makeStyles({
    container: {
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000',
        color: '#fff',
    },
    header: {
        height: "15vh",
        width: '100vw',
        borderBottom: '1px solid gray',
        display: "flex",
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    logo: {
        marginLeft: '3vw'

    },
    close: {
        color: '#fff',
        marginRight: '4vw'
    },
    icon: {
        fontSize: '55px',
    },
    body: {
        display: 'flex',
        flexDirection: 'column',
        fontWeight: '900',
        justifyContent: 'space-between',
        height: '70vh',
        marginLeft: '20vw',
        marginTop: '5vh',
    },
    link: {
        color: "#fff",
        width: 'max-content',
    }

})
export default useStyles;
